import React, { useState } from 'react';
import './ProgressBar.css';

interface ProgressBarProps {
    levels: Array<{
        level: number;
        experienceRequired: number;
    }>;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ levels }) => {
    const [currentExperience, setCurrentExperience] = useState(0);

    const totalExperienceRequired = levels.reduce((acc, level) => acc + level.experienceRequired, 0);

    const currentLevel = levels.find(({ experienceRequired }) => currentExperience < experienceRequired)?.level;

    const levelBlocks = levels.map(({ level, experienceRequired }) => (
        <div className="progress-level-block" key={level}>
            {/*<div className="progress-level-block__current-level">*/}
            {/*    <span className="progress-level-block__current-level-text">Текущий уровень</span>*/}
            {/*</div>*/}
            {/*<div className="progress-level-block__current-level progress-level-block__current-level_will-get">*/}
            {/*    <span className="progress-level-block__current-level-text">Текущий уровень</span>*/}
            {/*    <span className="progress-level-block__current-level-text progress-level-block__current-level-text_point">+5 поинтов</span>*/}
            {/*</div>*/}
            <div className="progress-level-number">{level}</div>
            <div
                className={`'' ${currentExperience >= experienceRequired ? 'progress-bar__badge' : ''}`}
                // style={{
                //     width: `${(experienceRequired / totalExperienceRequired) * 100}%`,
                //
                // }}
            />

            {/*<div className="progress-level-xp">*/}
            {/*    {currentExperience}/{experienceRequired} XP*/}
            {/*</div>*/}
        </div>
    ));

    const handleExperienceGain = (experience: number) => {
        setCurrentExperience((prevExperience) => Math.min(prevExperience + experience, totalExperienceRequired));
    };

    return (
        <div onClick={() => handleExperienceGain(100)} className="progress-container">
            <div className="progress-levels">{levelBlocks}</div>

            <div className="progress-bar-container">
                <div
                    className="progress-bar filled"
                    style={{
                        width: `${(currentExperience / totalExperienceRequired) * 100}%`,
                    }}
                />
                {/*<div className="progress-bar-text">*/}
                {/*    {currentExperience}/{totalExperienceRequired} XP*/}
                {/*</div>*/}
            </div>
            {/*<button className="progress-bar__button" onClick={() => handleExperienceGain(10)}>*/}
            {/*    Gain 10 XP*/}
            {/*</button>*/}
        </div>
    );
};
